import Cross from '../../assets/icons/Cross';
import { useRef } from 'react';

const Modal = ({ visible, setVisible, children, additionalClassName = '', renderClose = true }) => {
  const modalRef = useRef(null);

  const close = () => {
    setTimeout(() => setVisible(false), 50)
  }

  return (
    <>
      {visible && (
        <div
          style={{
            display: 'flex',
            direction: 'row',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            zIndex: '100',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(0,0,0,0.4)',
          }}
          className="fixed"
          onClick={(e) => {
            if (modalRef.current && modalRef.current.contains(e.target)) {
              return;
            }
            close()
          }}
        >
          {/* Attach modalRef to the modal content */}
          <div
            ref={modalRef}
            //className={`bg-white rounded-lg shadow-lg max-w-[90%] w-full md:w-2/3 lg:w-1/2 p-5 relative ${additionalClassName}`}
            className={`bg-white text-[#1A1A1A] rounded-lg shadow-lg p-5 relative ${additionalClassName}`}
          >
            {renderClose && (
              <button
                className="absolute top-2 right-2 text-gray-600 hover:text-gray-800"
                onClick={close}
              >
                <Cross />
              </button>
            )}
            {children}
          </div>
        </div>
      )}
    </>
  );
};

export default Modal;
